module.exports = __webpack_public_path__ + "img/gradient_wallpaper.4474587a.jpg";